import React from 'react';
import { CalendarDays } from 'lucide-react';
import ComingSoonPage from '@/components/ComingSoonPage';

/**
 * Crop Planner — Coming Soon until the real backend lands.
 *
 * Prior to PR 9 this page scaffolded a calendar + an "Add" button + a
 * list of mock events, but no `/api/planner/events` endpoint existed:
 * every date pick 404'd silently and swapped in the same four mock
 * rows, the Add button had no handler, and tapping an event did
 * nothing. The full implementation (events table, scoped CRUD, day
 * markers, edit dialog) is tracked as a backlog item — see the
 * platform-review handover doc, PR 9-full.
 */
export default function PlannerPage() {
  return (
    <ComingSoonPage
      titleKey="planner.title"
      bodyKey="planner.comingSoonBody"
      icon={CalendarDays}
      dataTestId="planner-coming-soon"
    />
  );
}
